var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-1-1"},[_c('Notification'),_c('main',{staticClass:"app-content",attrs:{"container-expand":""}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }